export default __webpack_public_path__ + "static/media/slider-crank.2386ba59.png";